import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { API_HANDLERS } from 'api/apiHandlers';
import { alert } from 'components';

export function useCreateFolderMutation() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { mutateAsync: createFolderMutation, isLoading } = useMutation(
    (data: { name: string; description?: string; category_id: string; parent_id?: string }) =>
      API_HANDLERS.FOLDERS.CREATE(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['folders']);
        alert.success(t('toasts.folder.success.create'));
      },
    },
  );

  return { createFolderMutation, isLoading };
}
